import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import bannerImage from "../../Images/Banner/recognisation-banner.webp";
import classroomImage from "../../Images/gov-body/rules.webp";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import "../../Placement.css";

const iqacFiles = [
    { name: "1st Meeting MOM 2021_IQAC", file: require("../../Images/IQAS/1st meeting MOM_IQAC .pdf") },
    { name: "1st Meeting_Circular_ IQAC", file: require("../../Images/IQAS/1st meeting circular_ IQAC .pdf") },
    { name: "2nd Meeting MOM 2021_IQAC", file: require("../../Images/IQAS/2nd meeting MOM_IQAC .pdf") },
    { name: "2nd Meeting_Circular_IQAC", file: require("../../Images/IQAS/2nd meeting circular_IQAC .pdf") },
    { name: "3rd Meeting MOM 2022_IQAC", file: require("../../Images/IQAS/3rd meeting MOM_IQAC .pdf") },
    { name: "3rd Meeting_Circular_IQAC", file: require("../../Images/IQAS/3rd meeting circular_IQAC.pdf") },
    { name: "4th Meeting MOM 2022_IQAC", file: require("../../Images/IQAS/4th meeting MOM_IQAC  (1).pdf") },
    { name: "4th Meeting_Circular_IQAC", file: require("../../Images/IQAS/4th meeting circular_IQAC .pdf") },
    { name: "5th Meeting MOM 2022_IQAC", file: require("../../Images/IQAS/4th meeting MOM_IQAC .pdf") },
    { name: "5th Meeting_Circular_IQAC", file: require("../../Images/IQAS/5th meeting circular_IQAC .pdf") },
    { name: "6th Meeting MOM 2023-24_IQAC", file: require("../../Images/IQAS/6th Meeting MOM 2023-24 -IQAC.pdf") },
    { name: "6th Meeting Circular_IQAC", file: require("../../Images/IQAS/6th Meeting Circular-IQAC.pdf") },
    { name: "7th Meeting MOM 2024-25_IQAC", file: require("../../Images/IQAS/7th Meeting MOM 2024-25-IQAC.pdf") },
    { name: "7th Meeting_Circular_IQAC", file: require("../../Images/IQAS/7th Meeting  Circular -IQAC.pdf") },
];

const iqacMembers = [
    {
        name: "Dr. Anand Mahalwar",
        designation: "Chairperson",
        remarks: "Head of the Institution"
    },
    {
        name: "Dr. B.P. Bhol",
        designation: "Senior Administrative Officer",
        remarks: "Registrar"
    },
    {
        name: "Dr. Poonam Verma",
        designation: "Faculty Member",
        remarks: "Faculty Member"
    },
    {
        name: "Dr. Ashwani Sahu",
        designation: "Faculty Member",
        remarks: "Faculty Member"
    },
    {
        name: "Dr. Rajesh Kumar",
        designation: "Faculty Member",
        remarks: "Faculty Member"
    },
    {
        name: "Dr. Shameem Ahmed Khan",
        designation: "Teacher Member",
        remarks: "Faculty Member"
    },
    {
        name: "Dr. Abha Mahalwar",
        designation: "Teacher Member",
        remarks: "Faculty Member"
    },
    {
        name: "Dr. Ankit Mishra",
        designation: "Teacher Member",
        remarks: "Faculty Member"
    },
    {
        name: "Dr. Vimla Sona",
        designation: "Teacher Member",
        remarks: "Faculty Member"
    },
    {
        name: "Ms. Kesharlata Sahu",
        designation: "Teacher Member",
        remarks: "Faculty Member"
    },
    {
        name: "Mr. Yashwant Raj",
        designation: "Management Representative",
        remarks: "Management Representative"
    },
    {
        name: "Ms. Rekha Sahu",
        designation: "Nominee - Alumni",
        remarks: "Alumni"
    },
    {
        name: "Mr. Sunil Sahu",
        designation: "Nominee - Student",
        remarks: "Student Representative"
    },
    {
        name: "Mr. Roshan Dewangan",
        designation: "Nominee - Employer/Industrialist",
        remarks: "Industrialist"
    },
    {
        name: "Mr. Paras Ram Sahu",
        designation: "Nominee - Employer/Industrialist",
        remarks: "Industrialist"
    },
    {
        name: "Ms. Raveli Sahu",
        designation: "Nominee - Stakeholder",
        remarks: "Stakeholder"
    },
    {
        name: "Dr. N. Kumar Swamy",
        designation: "IQAC Coordinator",
        remarks: "Senior Teacher"
    }
];

const IQAC = () => {
    return (
        <>
            <title>Internal Quality Assurance Cell (IQAC) | ISBM University</title>
            <meta
                name="description"
                content="Learn how ISBM University’s IQAC drives quality assurance, enhancement, and continuous improvement across academic activities."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="conatiner-xxl">
                        <div className="section-hero-content">
                            <h1>International Association of Universities</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    IQAC
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-light">
                <div className="container-xxl ptb-50">
                    <Row className="m-0">
                        <div className="col-md-6">
                            <h2 className="modern-title text-blue">IQAC</h2>
                            <div className="underline-divider mb-3"></div>
                            <p className="text-muted">
                                The IQAC is meant for planning, guiding, monitoring Quality Assurance (QA)
                                and Quality Enhancement (QE) in the academic activities of the University.
                                IQAC committee will make a significant and meaningful contribution in the
                                accreditation phase of University. The prime task of the IQAC is to develop
                                a system for conscious, consistent catalytic and continuous improvement in
                                the overall performance of University.
                            </p>
                            <p className="text-muted">

                            </p>
                        </div>
                        <div className="col-md-6">
                            <div className="governing-image-wrapper shadow">
                                <img src={classroomImage} alt="Governing Body" />
                            </div>
                        </div>
                    </Row>
                </div>
            </section>

            <div className="About_us11 py-5 container-xxl">
                <Row>
                    <Col lg={12}>
                        <h2 className="linkabout123">IQAC Meeting Details</h2>
                        <div className="underline-divider mb-3"></div>
                        <Row className="form-list g-4"> {/* Keep 'form-list' here */}
                            {iqacFiles.map((form, index) => (
                                <Col key={index} lg={4} md={6} sm={12}>
                                    <li className="downloadform-card shadow list-unstyled h-100 p-3">
                                        <div className="formIcon mb-2">
                                            <i className="fa fa-wpiqacFiles" aria-hidden="true"></i>
                                        </div>
                                        <div className="formname d-flex justify-content-between align-items-center w-100">
                                            <a
                                                href={form.file}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                download
                                                className="form-link"
                                            >
                                                {form.name}
                                            </a>
                                            <a
                                                href={form.file}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                download
                                                className="download-icon"
                                                aria-label="Download"
                                            >
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                            </a>
                                        </div>
                                    </li>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                </Row>
            </div>

            <section className="visa-section py-5 bg-light">
                <div className="container-xxl">
                    <h2 className="text-center modern-title text-blue">Committiee Member of IQAC</h2>
                    <div className="underline-center mb-5 mx-auto"></div>
                    <div className="row m-0">
                        {iqacMembers.map((member, index) => (
                            <div className="col-lg-4 col-md-6 d-flex mb-3" key={index}>
                                <div className="visa-box p-4 shadow w-100 h-100 d-flex flex-column">
                                    <div className="visahead">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="text-dark mb-0">{member.name}</h5>
                                            <span className="badge designation ms-2 ">{member.designation}</span>
                                        </div>
                                        <div className="underlinetwo"></div>
                                    </div>
                                    <ul className="mb-0 list-unstyled">
                                        <li>{member.remarks}</li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default IQAC;
